import React, { Suspense } from 'react';
import { LoadingScreen } from './LoadingScreen';

export function SuspenseWrapper(props: React.SuspenseProps & { name: string; fullScreen?: boolean; className?: string }) {
	return <Suspense fallback={props.fallback ?? <LoadingScreen {...props} />} {...props} />;
}
